import { IncomingMessage } from 'http';
import { NextApiRequestCookies } from 'next/dist/server/api-utils';
import Cookies from 'universal-cookie';
import { FeatureFlags } from '@/types/common';
import { UI_FEATURE_FLAGS } from '@/constants';
import { PROVIDER_SIGN_UP_BANNER_COOKIE_KEY } from '../ProviderSignUpBanner';

/**
 * Helper function to determine if the provider signup banner should be displayed
 * Takes into account both the feature flag and the cookie state
 *
 * @param req - Server request object to access cookies
 * @param ldClientFlags - Feature flags object
 * @returns boolean indicating if the banner should be shown
 */
export function getProviderBannerVisibility(
  req: (IncomingMessage & { cookies: NextApiRequestCookies }) | undefined,
  ldClientFlags?: FeatureFlags
): boolean {
  // Check if feature flag is enabled
  const isFlagEnabled = ldClientFlags?.[UI_FEATURE_FLAGS.PROVIDER_SIGNUP_BANNER.id]?.value === true;
  if (!isFlagEnabled) {
    return false;
  }

  // On server-side, check for the cookie in the request
  if (req?.headers?.cookie) {
    const cookies = new Cookies(req.headers.cookie);
    const cookieValue = cookies.get(PROVIDER_SIGN_UP_BANNER_COOKIE_KEY);
    if (cookieValue === 'true' || cookieValue === true) {
      return false;
    }
  }

  // If client-side or no cookie is found, show the banner
  return true;
}
